import type { ListSocialAccountsResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function listSocialAccounts(): Promise<ListSocialAccountsResponse> {
  return apiClient.url("/social-publishing/accounts").get().json();
}

export function useSocialAccounts(): UseQueryResult<
  ListSocialAccountsResponse,
  Error
> {
  return useQuery({
    queryFn: listSocialAccounts,
    queryKey: socialPublishingKeys.accounts(),
  });
}
